import React, { useState } from 'react';
import { makeStyles, TextField, InputAdornment, Button, CircularProgress } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { EmailOutlined, LockOutlined, SendOutlined, DashboardOutlined } from '@material-ui/icons';
import { fb } from '../../utils/Firebase';
import { useHistory } from 'react-router-dom';

const FormLogin = props => {

    const [ isLoading, setIsLoading ] = useState(false);
    const classes = useStyles();
    const { handleSubmit, errors, control } = useForm();
    const { setSnackbar } = props;
    const history = useHistory();
    //const { setIsLogged } = useContext(AuthContext);

    const onSubmit = data => {
        setIsLoading(true);
        const { email, password } = data;

        fb.auth().signInWithEmailAndPassword(email, password)
        .then(user => {
            setIsLoading(false);
            history.replace('/dashboard');
        }).catch(e => {
            setSnackbar({ message: 'Correo electrónico y/o contraseña incorrectos.', visible: true });
            setIsLoading(false);
        });
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={classes.form} >
            <div className={classes.containertitle}>
                <DashboardOutlined className={classes.icon} />
                <h3 className={classes.title}>CONSOLA DE ADMINISTRACIÓN</h3>
            </div>
            <Controller
                name='email'
                control={control}
                defaultValue=''
                render={({ onChange, value }) => (
                    <TextField
                        error={errors.email ? true : false}
                        label='Correo electrónico'
                        helperText={ errors.email ? errors.email.message : 'Ingrese el correo electrónico' }
                        fullWidth
                        disabled={isLoading}
                        size='small'
                        type='email'
                        variant="outlined"
                        style={{ marginBottom: 20, background: '#fff' }}
                        value={value || ''}
                        onChange={onChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EmailOutlined htmlColor='rgba(0,0,0,.4)' />
                                </InputAdornment>
                            )
                        }}
                    />
                )}
                rules={{
                    required: '* Campo obligatorio',
                    pattern: {
                        value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: 'El correo electrónico no es correcto'
                    }
                }}
            />

            <Controller
                name='password'
                control={control}
                defaultValue=''
                render={({ onChange, value }) => (
                    <TextField
                        error={errors.password ? true : false}
                        label='Contraseña'
                        helperText={ errors.password ? errors.password.message : 'Ingrese la contraseña' }
                        fullWidth
                        disabled={isLoading}
                        size='small'
                        type='password'
                        variant="outlined"
                        style={{ marginBottom: 20, background: '#fff' }}
                        value={value || ''}
                        onChange={onChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockOutlined htmlColor='rgba(0,0,0,.4)' />
                                </InputAdornment>
                            )
                        }}
                    />
                )}
                rules={{
                    required: '* Campo obligatorio'
                }}
            />

            <Button
                variant="contained"
                //color="primary"
                startIcon={isLoading ? <CircularProgress size={20} color='inherit' /> : <SendOutlined />}
                fullWidth
                disabled={isLoading}
                style={{ paddingTop: 7, paddingBottom: 7, background: '#4caf50', color: '#fff' }}
                size='medium'
                type='submit'
            >
                {isLoading ? 'Iniciando sesión...' : 'Ingresar'}
            </Button>
        </form>
    );
}

const useStyles = makeStyles({
    form:{
        width: 400,
        background: '#fff',
        padding: 20,
        borderRadius: 4,
        marginLeft: 15,
        marginRight: 15
    },
    containertitle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 10
    },
    title: {
        fontFamily: 'Roboto',
        color: 'rgba(0, 0, 0, .7)',
        marginTop: 5
    },
    icon: {
        fontSize: 50,
        color: 'rgba(0, 0, 0, .7)'
    }
});

export default FormLogin;